class CarouselNav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        let elements = document.querySelectorAll('[data-carousel-elements]');
        let elementNav = document.querySelector('[data-carousel-element-nav]');

        elementNav.style.width = elements[0].offsetHeight+'px';

        window.addEventListener('resize', (event) => {
            elementNav.style.width = elements[0].offsetHeight+'px';
        });
    }
}

export default CarouselNav;
